export const USERROLE_GET = 'USERROLE_GET';